<script setup="">
import { computed, inject } from "vue";

const props = defineProps({
  rounded: {
    type: Boolean,
    required: false
  },
  glow: {
    type: Boolean,
    required: false
  },
  variant: {
    type: String,
    required: false
  },
  outline: {
    type: Boolean,
    required: false
  },
  classes: {
    type: [Array, String, Object],
    required: false
  }
});

const twMerge = inject("twMerge");

const defaultClass = computed(() => {
  switch (props.variant) {
    case "primary":
      return props.outline ? "border border-primary text-primary" : "bg-primary text-white";
    case "secondary":
      return props.outline ? "border border-secondary text-secondary" : "bg-secondary text-white";
    case "info":
      return props.outline ? "border border-info text-info" : "bg-info text-white";
    case "success":
      return props.outline ? "border border-success text-success" : "bg-success text-white";
    case "warning":
      return props.outline ? "border border-warning text-warning" : "bg-warning text-white";
    case "error":
      return props.outline ? "border border-error text-error" : "bg-error text-white";
    default:
      return props.outline ? "border border-300 text-800 " : "bg-200 text-800 ";
  }
});

const rounded = computed(() => {
  return props.rounded ? "rounded-full" : "";
});

const glow = computed(() => {
  if (!props.glow) {
    return "";
  }

  switch (props.variant) {
    case "primary":
      return "shadow-soft shadow-primary/50 dark:shadow-success/50";
    case "secondary":
      return "shadow-soft shadow-secondary/50";
    case "info":
      return "shadow-soft shadow-info/50";
    case "success":
      return "shadow-soft shadow-success/50";
    case "warning":
      return "shadow-soft shadow-warning/50";
    case "error":
      return "shadow-soft shadow-error/50";
    default:
      return "shadow-soft shadow-zinc-200/50 dark:shadow-zinc-900/50";
  }
});

const computedClass = computed(() => twMerge(defaultClass.value, props.classes));
</script>

<template>
  <small class="badge cursor-pointer" :class="[computedClass, rounded, glow]">
    <slot />
  </small>
</template>
